package Utils

import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.intOrNull
import kotlinx.serialization.json.longOrNull
import printPlat
import kotlin.math.abs
import kotlin.math.max
import kotlin.math.roundToInt
import kotlin.math.roundToLong

val myMail = "nihulkav@gmail.com"
var RESOURCES_FOLDER = "./resources/"
val MAX_LARGE_VALUE = 1000000
var userInput: Map<String, String> = emptyMap()
val months_to_number: Map<String, Int> = mapOf(
        "ינואר" to 1, "פברואר" to 2, "מרץ" to 3, "אפריל" to 4, "מאי" to 5, "יוני" to 6, "יולי" to 7, "אוגוסט" to 8,
        "ספטמבר" to 9,
        "אוקטובר" to 10, "נובמבר" to 11, "דצמבר" to 12
)

fun prepareStrToJson(str: String,map: Map<Char, String>?=null): String {

    return str.replace(
        map?: mapOf(
            '\n' to "",
            '\"' to "",
            '\'' to "",
            '\r' to "",
            '\\' to "",
            '?' to "",
            '%' to ""
        )
    ).trim()

}

/** Strip formatting chars from ח.פ / business id before save (spaces, -, /, \\). */
fun prepareBusinessId(businessId: String?): String? {
    if (businessId == null) return null
    return businessId
        .replace("\"", "''")
        .replace("\n", "")
        .filter { it != ' ' && it != '-' && it != '/' && it != '\\' }
        .trim()
}
fun prepareStrToJsonWithLine(str: String,map: Map<Char, String>?=null): String {

    return str.replace(
        map?: mapOf(
            '\"' to "",
            '\'' to "",
            '\r' to "",
            '\\' to "",
            '?' to "",
            '%' to ""
        )
    ).trim()

}
fun smartSearch(str: String, full: String): Boolean {
    var i = 0
    str.forEachIndexed { index, s ->
        while (i < full.length && s != full[i])
            i += 1
        if (i == full.length)
            return false
        i += 1
    }
    return true
}

fun subStringMatch(str: String, full: String): Boolean {
    val splitSearch = str.split(" ")
    val splitFull = full.split(" ")
    splitSearch.forEachIndexed { index, s ->
        if (!splitFull.any { it.contains(s) })
            return false

    }
    return true
}
fun timeLock(hourLock:String): Boolean {
    val dt = DatesManipulator.dateNow()
    val time = DatesManipulator.getTime(dt).split(":")
    val hour = time[0].toInt()
    val min = time[1].toInt()
    val hours = hourLock.split(":")
    val lockHour = hours[0].toIntOrNull() ?:0
    val lockMin = if(hours.size==2) hours[1].toIntOrNull() ?:0 else 0
    // Inclusive cutoff: the cutoff minute itself is already closed (now >= cutoff).
    val lock_time = (lockHour>0 || lockMin>0) && (lockHour<hour || (lockHour==hour && lockMin<=min))
    return lock_time
}

/** Parses a JSON object keyed by ISRAEL weekday string ("1"=Sunday.."7"=Saturday), e.g. {"1":"14:00"}.
 * Returns the value for [weekday1to7], or null when absent/blank/unparsable. Shared by per-product
 * day_hour_locks and company-wide day_time_locks maps so both use identical parsing semantics. */
fun weekdayHourMapValue(raw: String?, weekday1to7: Int): String? {
    val json = raw?.takeIf { it.isNotBlank() && it != "None" && it != "null" } ?: return null
    return try {
        (Json.parseToJsonElement(json) as? kotlinx.serialization.json.JsonObject)
            ?.get(weekday1to7.toString())
            ?.let { it as? kotlinx.serialization.json.JsonPrimitive }
            ?.content
            ?.takeIf { it.isNotBlank() }
    } catch (e: Exception) {
        null
    }
}

/** Reads one platform-admin feature gate out of [Structs.CofcConf.admin_flags] JSON
 * (e.g. {"collage":1,"btc":1}). True only when the gate is explicitly on, so a company
 * whose gate was never set keeps the feature hidden. */
fun cofcAdminFlagEnabled(raw: String?, gate: String): Boolean {
    val json = raw?.takeIf { it.isNotBlank() && it != "None" && it != "null" } ?: return false
    return try {
        val value = (Json.parseToJsonElement(json) as? JsonObject)?.get(gate) as? JsonPrimitive
        value?.content == "1" || value?.content == "true"
    } catch (e: Exception) {
        false
    }
}

/** How a holiday window scopes clients or products. Missing mode on old rows:
 * empty ids → [ALL], otherwise [INCLUDE]. [CARD] uses the card's weekday mask and treats
 * [HolidayWindow.ids] as extras. [EXCLUDE] is a deny-list. */
enum class HolidayScopeMode { ALL, CARD, INCLUDE, EXCLUDE }

data class HolidayWindow(
    val active: Boolean,
    val deliveryDates: Set<String>,
    val orderUntil: String,
    val productIds: Set<Int>,
    val clientIds: Set<Int>,
    val productMode: HolidayScopeMode,
    val clientMode: HolidayScopeMode,
    val hideOthers: Boolean,
)

enum class HolidayProductVerdict { BYPASS, DENY, EXCLUSIVE_LOCK, KEEP }

data class HolidayDateEval(
    val reopen: Boolean,
    val exclusive: Boolean,
    val hideOthers: Boolean,
    val orderUntil: String? = null,
)

private fun holidayJsonInts(el: JsonElement?): Set<Int> {
    val arr = el as? JsonArray ?: return emptySet()
    return arr.mapNotNull { (it as? JsonPrimitive)?.content?.toIntOrNull()?.takeIf { n -> n > 0 } }.toSet()
}

private fun holidayScopeMode(raw: String?, idsEmpty: Boolean): HolidayScopeMode =
    when (raw?.trim()?.lowercase()) {
        "card" -> HolidayScopeMode.CARD
        "include" -> HolidayScopeMode.INCLUDE
        "exclude" -> HolidayScopeMode.EXCLUDE
        "all" -> HolidayScopeMode.ALL
        else -> if (idsEmpty) HolidayScopeMode.ALL else HolidayScopeMode.INCLUDE
    }

private fun holidayTruthy(value: JsonElement?): Boolean {
    val p = value as? JsonPrimitive ?: return false
    val c = p.content.trim()
    return c == "1" || c.equals("true", ignoreCase = true)
}

fun parseHolidayWindows(raw: String?): List<HolidayWindow> {
    val json = raw?.takeIf { it.isNotBlank() && it != "None" && it != "null" } ?: return emptyList()
    return try {
        val arr = Json.parseToJsonElement(json) as? JsonArray ?: return emptyList()
        arr.mapNotNull { el ->
            val obj = el as? JsonObject ?: return@mapNotNull null
            val orderUntil = (obj["order_until"] as? JsonPrimitive)?.content?.replace("T", " ")
                ?.takeIf { it.isNotBlank() } ?: return@mapNotNull null
            val dates = (obj["delivery_dates"] as? JsonArray)
                ?.mapNotNull { (it as? JsonPrimitive)?.content?.takeIf { d -> d.isNotBlank() } }
                ?.toSet() ?: return@mapNotNull null
            val productIds = holidayJsonInts(obj["product_ids"])
            val clientIds = holidayJsonInts(obj["client_ids"])
            val activeEl = obj["active"]
            val active = activeEl == null || run {
                val p = activeEl as? JsonPrimitive ?: return@run true
                p.content != "0" && !p.content.equals("false", ignoreCase = true)
            }
            HolidayWindow(
                active = active,
                deliveryDates = dates,
                orderUntil = orderUntil,
                productIds = productIds,
                clientIds = clientIds,
                productMode = holidayScopeMode((obj["product_mode"] as? JsonPrimitive)?.content, productIds.isEmpty()),
                clientMode = holidayScopeMode((obj["client_mode"] as? JsonPrimitive)?.content, clientIds.isEmpty()),
                hideOthers = holidayTruthy(obj["hide_others"]),
            )
        }
    } catch (e: Exception) {
        emptyList()
    }
}

private fun holidayDayInMask(mask: Int, weekday1to7: Int): Boolean =
    ((mask shr (weekday1to7 - 1)) and 1) == 1

private fun holidayNowKey(now: String): String = now.replace("T", " ").trim().take(16)

private fun holidayWindowOnDate(w: HolidayWindow, deliveryDateIso: String): Boolean =
    w.active && w.deliveryDates.contains(deliveryDateIso)

private fun holidayWindowLive(w: HolidayWindow, deliveryDateIso: String, now: String): Boolean =
    holidayWindowOnDate(w, deliveryDateIso) &&
        holidayNowKey(now) <= w.orderUntil.replace("T", " ").trim().take(16)

private fun holidayWindowExpired(w: HolidayWindow, deliveryDateIso: String, now: String): Boolean =
    holidayWindowOnDate(w, deliveryDateIso) &&
        holidayNowKey(now) > w.orderUntil.replace("T", " ").trim().take(16)

private fun holidayClientMatches(w: HolidayWindow, clientId: Int, daysMask: Int, weekday1to7: Int): Boolean =
    when (w.clientMode) {
        HolidayScopeMode.ALL -> true
        HolidayScopeMode.INCLUDE -> w.clientIds.contains(clientId)
        HolidayScopeMode.EXCLUDE -> !w.clientIds.contains(clientId)
        HolidayScopeMode.CARD -> holidayDayInMask(daysMask, weekday1to7) || w.clientIds.contains(clientId)
    }

private fun holidayMatchingWindows(
    windows: List<HolidayWindow>,
    clientId: Int,
    daysMask: Int,
    deliveryDateIso: String,
    nowIsrael: String,
    expired: Boolean,
): List<HolidayWindow> {
    val now = nowIsrael.replace("T", " ")
    val weekday = DatesManipulator.getDayOfWeekIsrael(deliveryDateIso) % 7 + 1
    return windows.filter { w ->
        val phase = if (expired) holidayWindowExpired(w, deliveryDateIso, now) else holidayWindowLive(w, deliveryDateIso, now)
        phase && holidayClientMatches(w, clientId, daysMask, weekday)
    }
}

private fun holidayProductBypasses(w: HolidayWindow, productId: Int): Boolean =
    when (w.productMode) {
        HolidayScopeMode.ALL -> true
        HolidayScopeMode.INCLUDE, HolidayScopeMode.CARD -> w.productIds.contains(productId)
        HolidayScopeMode.EXCLUDE -> false
    }

/** True when a live or expired holiday window matches this client and delivery date. */
fun holidayWindowAppliesToClient(
    raw: String?,
    clientId: Int,
    daysMask: Int,
    deliveryDateIso: String,
    nowIsrael: String,
): Boolean {
    val windows = parseHolidayWindows(raw)
    val key = DatesManipulator.normalizeToIsoDate(deliveryDateIso)
    return holidayMatchingWindows(windows, clientId, daysMask, key, nowIsrael, expired = false).isNotEmpty() ||
        holidayMatchingWindows(windows, clientId, daysMask, key, nowIsrael, expired = true).isNotEmpty()
}

fun evaluateHolidayDate(
    raw: String?,
    clientId: Int,
    daysMask: Int,
    deliveryDateIso: String,
    nowIsrael: String,
): HolidayDateEval {
    val matching = holidayMatchingWindows(parseHolidayWindows(raw), clientId, daysMask, deliveryDateIso, nowIsrael, expired = false)
    val reopen = matching.any { it.productMode != HolidayScopeMode.EXCLUDE }
    val exclusive = matching.any { it.productMode == HolidayScopeMode.INCLUDE }
    val hideOthers = matching.any { it.hideOthers }
    val orderUntil = matching.filter { it.productMode != HolidayScopeMode.EXCLUDE }
        .minOfOrNull { it.orderUntil }
    return HolidayDateEval(reopen = reopen, exclusive = exclusive, hideOthers = hideOthers, orderUntil = orderUntil)
}

fun holidayProductVerdict(
    raw: String?,
    productId: Int,
    clientId: Int,
    daysMask: Int,
    deliveryDateIso: String,
    nowIsrael: String,
): HolidayProductVerdict {
    val windows = parseHolidayWindows(raw)
    val matching = holidayMatchingWindows(windows, clientId, daysMask, deliveryDateIso, nowIsrael, expired = false)
    if (matching.isNotEmpty()) {
        if (matching.any { it.productMode == HolidayScopeMode.EXCLUDE && it.productIds.contains(productId) }) {
            return HolidayProductVerdict.DENY
        }
        if (matching.any { holidayProductBypasses(it, productId) }) return HolidayProductVerdict.BYPASS
        if (matching.any { it.productMode == HolidayScopeMode.INCLUDE }) return HolidayProductVerdict.EXCLUSIVE_LOCK
        return HolidayProductVerdict.KEEP
    }
    val expired = holidayMatchingWindows(windows, clientId, daysMask, deliveryDateIso, nowIsrael, expired = true)
    if (expired.any { holidayProductBypasses(it, productId) }) return HolidayProductVerdict.DENY
    return HolidayProductVerdict.KEEP
}

fun holidayHidesProduct(
    raw: String?,
    productId: Int,
    clientId: Int,
    daysMask: Int,
    deliveryDateIso: String,
    nowIsrael: String,
): Boolean {
    val matching = holidayMatchingWindows(parseHolidayWindows(raw), clientId, daysMask, deliveryDateIso, nowIsrael, expired = false)
    if (matching.none { it.hideOthers }) return false
    val verdict = holidayProductVerdict(raw, productId, clientId, daysMask, deliveryDateIso, nowIsrael)
    return verdict == HolidayProductVerdict.DENY || verdict == HolidayProductVerdict.EXCLUSIVE_LOCK
}

/** Evaluates [Structs.CofcConf.product_date_windows]: true when a live window matching
 * [clientId] tells this product to bypass the date/hour/lead-time chain. Inactive windows
 * are ignored. Callers must still enforce forceLock/availability separately. */
fun productDateWindowAllows(
    raw: String?,
    productId: Int,
    deliveryDateIso: String,
    nowIsrael: String,
    clientId: Int = 0,
    daysMask: Int = 127,
): Boolean = holidayProductVerdict(raw, productId, clientId, daysMask, deliveryDateIso, nowIsrael) ==
    HolidayProductVerdict.BYPASS

fun holidayReopensDeliveryDate(
    raw: String?,
    clientId: Int,
    daysMask: Int,
    deliveryDateIso: String,
    nowIsrael: String,
): Boolean = evaluateHolidayDate(raw, clientId, daysMask, deliveryDateIso, nowIsrael).reopen


val number_to_month: Map<Int, String> = mapOf(
        1 to "ינואר", 2 to "פברואר", 3 to "מרץ", 4 to "אפריל", 5 to "מאי", 6 to "יוני", 7 to "יולי", 8 to "אוגוסט",
        9 to "ספטמבר",
        10 to "אוקטובר", 11 to "נובמבר", 12 to "דצמבר"
)
val Banks: Map<String, Int> = mapOf(
        "בנק אגוד לישראל" to 13,
        "בנק דיסקונט" to 11,
        "בנק הפועלים" to 12,
        "בנק יהב" to 4,
        "בנק ירושלים" to 54,
        "בנק לאומי" to 10,
        "בנק מזרחי" to 20,
        "בנק מסד" to 46,
        "הבנק הבינלאומי" to 31,
        "בנק מרכנתיל" to 17,
        "בנק אוצר החייל" to 14,
        "בנק הדואר" to 9,
        "וואן זירו" to 18,
    "פאגי בנק פועלי אגודת ישראל" to 52,
    "בנק פועלי אגודת ישראל" to 52,
    "בנק פלסטין" to 38,
    "בנק סיטי" to 22,
    "GROW" to 35,
        "בחר בנק" to -1
)
val InverseBanks: Map<Int, String> = mapOf(
        13 to "בנק אגוד לישראל",
        11 to "בנק דיסקונט",
        12 to "בנק הפועלים",
        4 to "בנק יהב",
        54 to "בנק ירושלים",
        10 to "בנק לאומי",
        20 to "בנק מזרחי",
        46 to "בנק מסד",
        31 to "הבנק הבינלאומי",
        17 to "בנק מרכנתיל",
        14 to "בנק אוצר החייל",
        9 to "בנק הדואר",
        18 to "וואן זירו",
        52 to "פאגי בנק פועלי אגודת ישראל",
        38 to "בנק פלסטין",
    22 to "בנק סיטי",
    35 to "GROW",
        -1 to "בחר בנק"
)
// Placeholder (-1) must stay first: Android spinners and web Autocomplete default to index 0.
// Latin names like "GROW" would otherwise sort before Hebrew and become the cash/empty default.
val banks = Banks.entries
        .sortedWith(compareBy<Map.Entry<String, Int>> { it.value != -1 }.thenBy { it.value }.thenBy { it.key })
        .map { "${it.key}-${it.value}" }

fun banksPlaceholderIndex(): Int {
    val i = banks.indexOfFirst { it.contains("בחר בנק") }
    return if (i >= 0) i else 0
}

/** Numeric code from a "NAME-CODE" label. Placeholder ("בחר בנק--1") → empty. */
fun bankCodeFromLabel(label: String): String {
    val m = Regex("""-(-?\d+)$""").find(label) ?: return ""
    val code = m.groupValues[1]
    return if (code == "-1") "" else code
}

fun bankLabelForCode(code: String): String {
    if (code.isEmpty() || code == "-1") {
        return banks.firstOrNull { it.contains("בחר בנק") } ?: ""
    }
    return banks.firstOrNull { bankCodeFromLabel(it) == code }
            ?: banks.firstOrNull { it.endsWith("-$code") }
            ?: ""
}

/** Last-cheque memory: bank code, account, branch — cheque number is never remembered. */
data class RememberedCheque(
    val bankId: String = "",
    val account: String = "",
    val branch: String = "",
) {
    fun isBlank(): Boolean {
        val bankEmpty = bankId.isBlank() || bankId == "0" || bankId == "-1"
        return bankEmpty && account.isBlank() && branch.isBlank()
    }

    fun encode(): String = "$bankId,$account,$branch"
}

fun parseRememberedCheque(raw: String?): RememberedCheque? {
    if (raw.isNullOrBlank()) return null
    val d = raw.split(",")
    val mem = RememberedCheque(
        bankId = d.getOrNull(0).orEmpty().trim(),
        account = d.getOrNull(1).orEmpty().trim(),
        branch = d.getOrNull(2).orEmpty().trim(),
    )
    return mem.takeUnless { it.isBlank() }
}

fun rememberedChequePrefsKey(company: String, entityId: Int, supplier: Boolean): String =
    "${company}_${if (supplier) "supplier" else "client"}_$entityId"

fun rememberedBankCode(bankId: String): String {
    val t = bankId.trim()
    if (t.isEmpty() || t == "0" || t == "-1") return ""
    t.toIntOrNull()?.let { n -> if (n > 0) return n.toString() }
    Banks[t]?.let { if (it > 0) return it.toString() }
    return bankCodeFromLabel(t)
}

fun rememberedChequeSpinnerIndex(bankId: String): Int {
    val code = rememberedBankCode(bankId)
    if (code.isEmpty()) return banksPlaceholderIndex()
    val byCode = banks.indexOfFirst { bankCodeFromLabel(it) == code }
    if (byCode >= 0) return byCode
    val name = InverseBanks[code.toIntOrNull() ?: Int.MIN_VALUE].orEmpty()
    if (name.isNotEmpty()) {
        val byName = banks.indexOfFirst { it.contains(name) }
        if (byName >= 0) return byName
    }
    return banksPlaceholderIndex()
}

val baseOrderDaysToData: Map<Int, String> = mapOf(
        0 to "2010-01-03",
        1 to "2010-01-04",
        2 to "2010-01-05",
        3 to "2010-01-06",
        4 to "2010-01-07",
        5 to "2010-01-08",
        6 to "2010-01-09",
        7 to "2010-01-10",
        )
val hebrewDayToInt: Map<String, Int> = mapOf(
        "א" to 1,
        "ב" to 2,
        "ג" to 3,
        "ד" to 4,
        "ה" to 5,
        "ו" to 6,
        "ש" to 7,
        )
val inverseBaseOrderDaysToData: Map<String, String> = mapOf(
        "2010-01-03" to "בסיס א",
        "2010-01-04" to "בסיס א",
        "2010-01-05" to "בסיס ב",
        "2010-01-06" to "בסיס ג",
        "2010-01-07" to "בסיס ד",
        "2010-01-08" to "בסיס ה",
        "2010-01-09" to "בסיס ו",
        "2010-01-10" to "בסיס ז",
)

fun isBaseOrderDate(date: String?): Boolean {
    val key = date?.trim()?.take(10).orEmpty()
    return inverseBaseOrderDaysToData.containsKey(key)
}

/** Priority CUSTWEEKDAY key ("1"=Sunday … "7"=Saturday). Not the calendar weekday of the 2010 date. */
fun baseOrderWeekday(date: String?): Int? {
    val key = date?.trim()?.take(10).orEmpty()
    return baseOrderDaysToData.entries.firstOrNull { it.value == key && it.key in 1..7 }?.key
}

val unclosed_date = "2011-01-01"

/** A value for `--key`, including a negative id (`-10`) or a list (`-10,-11`). */
private val OPT_VALUE_NUMBER = Regex("""-?\d+(\.\d+)?(,-?\d+(\.\d+)?)*""")

fun getopt(args: Array<String>): Map<String, String> {
    var last = ""
    var expecting = false

    return args.fold(mutableMapOf()) { acc: MutableMap<String, String>, s: String ->
        acc.apply {
            if (s.startsWith("--")) {
                last = s.substring(2)
                expecting = true
            } else if (expecting && (!s.startsWith("-") || OPT_VALUE_NUMBER.matches(s))) {
                // `--ent_id -10` is a menu id, not a flag named "10".
                this[last] = s
                expecting = false
            } else if (s.startsWith("-")) {
                this[s.substring(1)] = ""
                expecting = false
            } else {
                this[last] = s
                expecting = false
            }
        }
    }
}

fun roundToDecimals(f: Float, decimals: Int): Float {
    var dotAt = 1
    repeat(decimals) { dotAt *= 10 }
    val roundedValue = (f * dotAt).roundToLong()
    return (roundedValue / dotAt) + (roundedValue % dotAt).toFloat() / dotAt
}

fun prettyRoundString(f: Float, decimals: Int): String {
    val new_f = roundToDecimals(f, decimals)
    val int = new_f.toInt()
    if (int.toFloat() == new_f)
        return int.toString()
    return new_f.toString()
}

fun splitNameToEqSize(name: String, size: Int = 2): List<Int> {
    val slices = mutableListOf<Int>()
    splitNameToEqSizeWrapper(name, size, slices)
    return slices
}

fun splitNameToEqSizeWrapper(name: String, size: Int = 2, res: MutableList<Int>) {
    val length = name.length
    val mid: Int = length / size
    var upperInd: Int = mid
    var lowerInd: Int = mid

    while (upperInd < length && name[upperInd] != ' ')
        upperInd += 1
    while (lowerInd >= 0 && name[lowerInd] != ' ')
        lowerInd -= 1
    val worstUpperSize: Int = max(length - upperInd, upperInd)
    val worstLowerSize: Int = max(lowerInd, length - lowerInd)
    if (worstUpperSize > worstLowerSize) {
        res.add(lowerInd)
    } else
        res.add(upperInd)
    if (size == 2) {
        return
    } else {
        splitNameToEqSizeWrapper(name.substring(res.last()), size - 1, res)
    }

}


fun <K, V> MutableMap<K, V>.putIfAbsent(key: K, value: V) {
    if (!containsKey(key)) {
        this[key] = value
    }
}

fun getJsonWithConfig(): Json {
    return Json {
        allowStructuredMapKeys = true
        coerceInputValues = true;
        allowSpecialFloatingPointValues = true; encodeDefaults = false; isLenient = true;ignoreUnknownKeys = true
    }
}

/**
 * Dump APIs put the payload in `status_msg` as a JSON array/object.
 * [JsonElement.toString] is not a guaranteed JSON encoder on JS — re-parse of
 * that string can yield `[]` / ClassCastException. Encode properly instead.
 */
fun dumpStatusMsgJson(elem: JsonObject): String {
    val msg = elem["status_msg"] ?: return "[]"
    return when (msg) {
        is JsonArray, is JsonObject -> getJsonWithConfig().encodeToString(JsonElement.serializer(), msg)
        is JsonPrimitive -> msg.contentOrNull ?: msg.toString()
        else -> msg.toString()
    }
}

fun fixJsonInternal(s: String): String {

    return (s).map {
        when (it) {
            '\"' -> {
                '\''
            }
//            '\\' -> {
//                ""
//            }
            else -> {
                it
            }
        }

    }.joinToString("")

}

fun fixJson(s: String): String {

    return (s).map {
        when (it) {
            '\'' -> {
                '\"'
            }

            '\"' -> {
                '\''
            }
//            '\\' -> {
//                ""
//            }
            else -> {
                it
            }
        }

    }.joinToString("")

}

fun Boolean.toInt(): Int {
    return if (this)
        1
    else 0
}

fun String?.isNotEmpty(cond: Boolean = true, default: String): String {
    if (!this.isNullOrEmpty() && cond)
        return this
    return default
}

fun String.replace(map: Map<Char, String>): String {
    return this.map { map[it] ?: it.toString() }.joinToString("").trim()
}

val regularStrClean = mapOf('\n' to "", '\"' to "")
val regularFullStrClean = mapOf('\n' to "", '\"' to "", '\r' to "", '\t' to "", "\'" to "")
fun String.cut(size: Int, end: Boolean = false): String {
    if (this.length < size)
        return this

    return if (end) this.takeLast(size) else this.take(size)
}

fun Float.isZero(): Boolean {
    return this == 0f
}
fun Float.roundZeroSmall(th:Float=0.1f): Float {
    return if(abs(this) <= th) 0f else this
}
fun Float?.isNullOrZero(): Boolean {
    return this == null || this == 0f
}

val badPhoto =
        "data:image/jpeg;base64,eyJzdGF0dXMiOiJFUlJPUiIsInN0YXR1c19tc2ciOiJJbnRlcm5hbCBFcnJvciJ9Cg==".encodeToByteArray()

/**
 * True when [bytes] look like a real raster image (JPEG/PNG/GIF/WEBP).
 *
 * Catalog sync used to save HTTP error JSON (`{"status":"ERROR",...}`) and the
 * in-memory [noImgPhoto]/[badPhoto] data-URL placeholders as `{id}.jpg`. Those
 * files exist on disk so the tablet thought the photo was already cached, but
 * Glide cannot decode them — the user keeps seeing the default image.
 */
fun isLikelyRasterImage(bytes: ByteArray): Boolean {
    if (bytes.size < 12) return false
    val b0 = bytes[0].toInt() and 0xFF
    val b1 = bytes[1].toInt() and 0xFF
    val b2 = bytes[2].toInt() and 0xFF
    val b3 = bytes[3].toInt() and 0xFF
    if (b0 == 0xFF && b1 == 0xD8) return true
    if (b0 == 0x89 && b1 == 0x50 && b2 == 0x4E && b3 == 0x47) return true
    if (b0 == 0x47 && b1 == 0x49 && b2 == 0x46) return true
    if (b0 == 0x52 && b1 == 0x49 && b2 == 0x46 && b3 == 0x46 && bytes.size >= 12) {
        val b8 = bytes[8].toInt() and 0xFF
        val b9 = bytes[9].toInt() and 0xFF
        val b10 = bytes[10].toInt() and 0xFF
        val b11 = bytes[11].toInt() and 0xFF
        return b8 == 0x57 && b9 == 0x45 && b10 == 0x42 && b11 == 0x50
    }
    return false
}

/**
 * S3 image_s_find values: legacy APIs sent `1` (presence only). Current APIs send
 * the object byte size. Treat `<= 1` as "size unknown" so we only compare when
 * the server actually gave us a file length.
 */
fun remoteImageSizeFromMeta(value: JsonElement): Long {
    val p = value as? JsonPrimitive ?: return 0L
    val n = p.longOrNull ?: p.intOrNull?.toLong() ?: p.content.toLongOrNull() ?: 0L
    return if (n > 1L) n else 0L
}

val noImgPhoto =
        "data:image/png;base64,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".encodeToByteArray()


enum class ReportType {
    DATA_TO_ACCOUNTANT,
    DATA_TO_RECIPT,
    DATA_TO_INVOICES,
    DATA_TO_GAIN,
    DATA_TO_GAIN_SUP,
    DATA_TO_OPEN_CARTESET,
    DATA_TO_DEBTS,
    DATA_TO_DEBTS_DRIVER,
    DATA_TO_DEBTS_INVOICES,
    DATA_TO_DEBTS_INVOICES_OPEN,
    DATA_TO_KUPA,
    DATA_TO_GIUL,
    DATA_TO_HAFKADA,
    DATA_TO_CATEGORY,
    DATA_TO_CATEGORY_2,
    DATA_TO_MONTHLY,
    DATA_TO_INVENTORY,
    DATA_TO_NEW_CLIENTS,
    DATA_TO_PRODUCT,
    /** Active products with no sales in the date range. Optional param: `category=` or `category2=`. */
    DATA_TO_PRODUCTS_NOT_BOUGHT,
    DATA_TO_PRODUCT_CLIENTS,
    DATA_TO_GAIN_BY_DOC,
    DATA_TO_LOW_PROFITABILITY,
    DATA_TO_DRIVER_SALE,
    DATA_TO_DRIVER_SALE_PRODUCT,
    /** Orders in range (or `param` order ids), carton estimate from product volume, by driver. */
    DATA_TO_DRIVER_KARTON,
    /** Same carton data as [DATA_TO_DRIVER_KARTON], grouped by driver then product. */
    DATA_TO_DRIVER_KARTON_PRODUCT,
    DATA_TO_PRODUCT_NOT_SALE,
    DATA_TO_PRICE_EXCEPTION,
    DATA_TO_GAIN_BY_CLIENT,
    DATA_TO_SALES_BY_CLIENT,
    DATA_TO_COLLECTION_ORDERS,
    DATA_TO_KLINZ,
    DATA_TO_MARKETING_SUMMARY,
    DATA_TO_CLIENT_ACTIVITY,
    DATA_TO_GIUL_OPEN,
    DATA_TO_AGENT_SALE_CATEGORY,
    DATA_TO_AGENT_SALE_CATEGORY_2,
    DATA_TO_AGENT_SALE_PRODUCT,
    DATA_TO_AGENT_GAIN,
    DATA_TO_CLIENTS_NO_INVOICE,
    DATA_TO_SALES_STATUS,
    /** Orders in the date range vs linked deliveries/invoices (not arbitrary notes in the range). */
    DATA_TO_ORDERS_VS_NOTES,
    DATA_TO_SUP_DEBTS,
    DATA_TO_SUP_DEBTS_INVOICES,
    DATA_TO_SUP_DEBTS_INVOICES_OPEN,
    DATA_TO_SUP_MONTHLY,
    /** Supplier tax invoices (חשבונית ספק / קבלה / זיכוי), same layout as [DATA_TO_INVOICES]. */
    DATA_TO_SUP_INVOICES,
    /** client_prices rows whose price date is in the range, with previous → new price and discount. */
    DATA_TO_PRICE_CHANGES,

}
